"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalFormDisclaimer = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const LegalFormDisclaimer = ({ disclaimer }) => {
    const basicTextStyle = {
        color: components_core_1.TokenTextColor.secondary,
        fontSize: index_1.TextSize.TextSize12,
        lineHeight: index_1.TextLineHeight.TextLineHeight20
    };
    const tagOverrides = {
        span: (0, components_core_1.createTagOverride)(index_1.TextCustom, {
            tag: components_core_1.TextTag.p,
            appearance: components_core_1.TokenTextAppearance.copy100,
            style: basicTextStyle
        }),
        a: (0, components_core_1.createTagOverride)(index_1.Link, {
            isInline: false,
            target: '_blank',
            color: components_core_1.TokenTextColor.inherit
        })
    };
    return (react_1.default.createElement(index_1.TextCustom, { appearance: components_core_1.TokenTextAppearance.copy100, style: basicTextStyle },
        react_1.default.createElement(components_core_1.Richtext, { markdown: disclaimer, overrides: tagOverrides })));
};
exports.LegalFormDisclaimer = LegalFormDisclaimer;
